import { Fragment } from 'react';

import { formatDate } from '../../utils/formatters.js';

export function MilestoneTimeline({ milestones }) {
  if (!milestones || milestones.length === 0) {
    return null;
  }
  const firstOpenIndex = milestones.findIndex((m) => !m.isDone);
  return (
    <div className="timeline">
      {milestones.map((m, i) => {
        const dotClass = m.isDone ? 'done' : i === firstOpenIndex ? 'next' : '';
        return (
          <Fragment key={m.id}>
            {i > 0 && <div className={`timeline-line${milestones[i - 1].isDone ? ' done' : ''}`} />}
            <div className="timeline-node">
              <div className={`timeline-dot ${dotClass}`} />
              <div style={{ marginTop: 6 }}>{m.title}{m.isDone ? ' ✓' : ''}</div>
              <div style={{ color: 'var(--color-text-muted)' }}>{formatDate(m.dueDate)}</div>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
